import Service from './baseService';

export const GetPaymentTermsService = () => {
    return Service.get(`/customer/payment-terms`);
};
